import React from "react";
import "./Chatbot.css";
import ChatbotLogic from "./ChatbotLogic";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Spinner from "react-bootstrap/Spinner";

export default function Chatbot() {
  const logic = ChatbotLogic();

  return (
    <>
      {/* Chatbot Toggle Button */}
      {!logic.isOpen && (
        <div className="chatbot-toggle" onClick={() => logic.setIsOpen(true)}>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16Z"
              fill="white"
            />
            <circle cx="7" cy="9" r="1" fill="white" />
            <circle cx="12" cy="9" r="1" fill="white" />
            <circle cx="17" cy="9" r="1" fill="white" />
          </svg>
        </div>
      )}

      {/* Chatbot Window */}
      {logic.isOpen && (
        <div className="chatbot-container">
          <div className="chatbot-header">
            <div>
              <h6 className="m-0">BulkHours Assistant</h6>
              {!logic.isConnected && (
                <small className="connection-status">⚠️ Connection issues</small>
              )}
            </div>
            <Button
              variant="link"
              className="chatbot-close p-0"
              onClick={() => logic.setIsOpen(false)}
            >
              ×
            </Button>
          </div>

          <div className="chatbot-messages" ref={logic.messagesEndRef}>
            {logic.messages.map((message, index) => (
              <div
                key={index}
                className={`chatbot-message ${
                  message.type === "user" ? "user-message" : "bot-message"
                } ${message.isError ? "error-message" : ""} ${message.isWelcome ? "welcome-message" : ""}`}
              >
                <div className="message-content">
                  {message.formattedContent ? (
                    <div 
                      dangerouslySetInnerHTML={{ 
                        __html: message.formattedContent 
                      }}
                    />
                  ) : (
                    <div>{message.content}</div>
                  )}
                </div>
                <div className="message-time">
                  {message.timestamp}
                </div>
              </div>
            ))}

            {logic.isLoading && (
              <div className="chatbot-message bot-message">
                <div className="message-content">
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                  Thinking...
                </div>
              </div>
            )}
          </div>

          <div className="chatbot-input">
            {/* Example Questions */}
            {logic.messages.length <= 1 && (
              <div className="example-questions">
                <div className="text-muted mb-2" style={{ fontSize: '10px' }}>Try to asking about:</div>
                <ul className="examples-list list-unstyled mb-0">
                  <li>
                    <button
                      type="button"
                      className="btn btn-link text-secondary text-decoration-none p-0"
                      onClick={() => logic.setExampleQuestion("How much time logged for project 6568330213?")}
                      style={{ fontSize: '12px', border: 'none', background: 'none' }}
                    >
                      <svg
                        width="12"
                        height="12"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="me-2"
                        style={{ marginBottom: '2px' }}
                      >
                        <path
                          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z"
                          fill="currentColor"
                        />
                      </svg>
                      Project hours
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      className="btn btn-link text-secondary text-decoration-none p-0"
                      onClick={() => logic.setExampleQuestion("What's the status of project 6568330213?")}
                      style={{ fontSize: '12px', border: 'none', background: 'none' }}
                    >
                      <svg
                        width="12"
                        height="12"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="me-2"
                        style={{ marginBottom: '2px' }}
                      >
                        <path
                          d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
                          fill="currentColor"
                        />
                      </svg>
                      Project status
                    </button>
                  </li>
                  <li>
                    <button
                      type="button"
                      className="btn btn-link text-secondary text-decoration-none p-0"
                      onClick={() => logic.setExampleQuestion("Show remaining hours for project 6568330213")}
                      style={{ fontSize: '12px', border: 'none', background: 'none' }}
                    >
                      <svg
                        width="12"
                        height="12"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="me-2"
                        style={{ marginBottom: '2px' }}
                      >
                        <path
                          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
                          fill="currentColor"
                        />
                      </svg>
                      Remaining hours
                    </button>
                  </li>
                </ul>
              </div>
            )}

            <Form onSubmit={logic.handleSubmit}>
              <div className="input-group">
                <Form.Control
                  as="textarea"
                  rows={1}
                  placeholder="Ask me anything..."
                  value={logic.inputMessage}
                  onChange={(e) => logic.setInputMessage(e.target.value)}
                  disabled={logic.isLoading || !logic.isConnected}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter' && !e.shiftKey) {
                      e.preventDefault();
                      logic.handleSubmit(e);
                    }
                  }}
                  style={{ resize: 'none', minHeight: '40px', maxHeight: '100px', fontSize: '12px' }}
                />
                <Button
                  type="submit"
                  variant="primary"
                  disabled={logic.isLoading || !logic.inputMessage.trim() || !logic.isConnected}
                >
                  {logic.isLoading ? (
                    <Spinner size="sm" animation="border" />
                  ) : (
                    "Send"
                  )}
                </Button>
              </div>
            </Form>
            
            {!logic.isConnected && (
              <div className="connection-warning">
                <small className="text-warning">
                  ⚠️ Connection to RAG Engine lost. 
                  <button 
                    type="button"
                    className="btn btn-blue"
                    onClick={logic.checkConnection}
                  >
                    Retry
                  </button>
                </small>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
